<template>
  <div class="hints-editor-container">
    <div>
      <h1>Edit Hint</h1>
    </div>
    <div class="flex items-center items-baseline">
      <label for="hint name">NAME:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionHints.name"
          v-validate="'required'"
          type="text"
          name="hint name"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("hint name") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label for="hint point">POINTS:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionHints.points"
          v-validate="'required|numeric|min_value:1'"
          type="text"
          name="hint point"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("hint point") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label class="mr-2">CMS ID:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionHints.cms_id"
          type="text"
          class="course-create-input"
        />
      </div>
    </div>
    <div class="flex">
      <div class="w-1/2">
        <div class="block text-center">
          Content
        </div>
        <MarkdownReadingEditor v-model="questionHints.content" />
        <small class="err-msg text-red">
          {{ veeValidateErrors.first("hint content") }}
        </small>
      </div>
      <div class="w-1/2">
        <div class="text-center">Preview</div>
        <VueMarkdown
          v-if="questionHints.content"
          :source="getRenderedMarkdownToHTML()"
          class="markdown-preview"
        />
      </div>
    </div>
    <div class="small-12 columns">
      <button
        class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-1 hover:bg-green-900"
        @click="updateHint"
      >
        Update Hint
      </button>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"
import MarkdownReadingEditor from "@/components/questions/MarkdownReadingEditor"
import markdownHelpers from "@/utils/markdownEditorHelpers"

export default {
  components: {
    MarkdownReadingEditor,
    VueMarkdown,
  },
  props: {
    isRoot: {
      type: Boolean,
      required: false,
      default: true,
    },
    hintId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      type: 10,
      questionHints: {},
      markdownRenderer: undefined,
    }
  },
  created() {
    this.getQuestion()
    this.markdownRenderer = window.markdownit()
  },
  methods: {
    getQuestion() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${
          this.hintId ? this.hintId : this.$route.params.id
        }`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.questionHints = res.data.data
          window.pageTitle = `Edit - ${this.questionHints.name}`
        })
        .catch(error => {
          this.$noty.error(`Failed to get the hints ${error}`)
        })
    },
    updateHint() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the error and try again")
          return
        }
        this.questionHints.cms_id = this.questionHints.cms_id
          ? this.questionHints.cms_id
          : null
        this.axios({
          method: "put",
          url: `${siteConfig.siteURL}questions/${
            this.hintId ? this.hintId : this.$route.params.id
          }`,
          data: this.questionHints,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(response => {
            this.$emit("HINT_UPDATED", {
              hintName: response.data.name,
              hintPoints: response.data.points,
              hintId: response.data.id,
            })
            this.$noty.success("Hint is updated successfully")
            if (this.isRoot) {
              this.$router.push({ name: "HintList" })
            }
          })
          .catch(error => {
            this.$noty.error(`Failed to update the hint ${error}`)
          })
      })
    },
    getRenderedMarkdownToHTML() {
      return this.markdownRenderer.render(
        markdownHelpers.decodeIDsToMarkdownLinks(this.questionHints.content, [])
      )
    },
  },
}
</script>

<style scoped>
.is-invalid {
  border-color: #ff5151;
}
.input-wrapper {
  margin: 0.5rem auto;
  margin-left: 2rem;
}
.course-create-input {
  width: 100%;
}
.hints-editor-container {
  width: 98%;
}
</style>
